import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

// Services
import useCampService from '../../../../../../../services/campService';

// Components
import InputNumber from '../../../../../../atoms/InputNumber/InputNumber';
import SkeletonLoader from '../../../../../../molecules/SkeletonLoader/SkeletonLoader';
import TagsInput from '../../../../../../molecules/TagsInput/TagsInput';

function Format({ formik, isCreation }) {
  const { t } = useTranslation();

  const { getCampStartDays, getCampFormats } = useCampService();

  const { data: startDays, isLoading: isStartDaysLoading } = useQuery('getCampStartDays', getCampStartDays);
  const { data: formats, isLoading: isFormatsLoading } = useQuery('getCampFormats', getCampFormats);

  const getInputTags = (name, options, isLoading, transKeyForOptions) => (
    isLoading ? (
      <div className="d-flex f-wrap">
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
      </div>
    ) : (
      options?.length ? (
        <TagsInput
          name={name}
          options={options.map((option) => ({ label: t(`${transKeyForOptions}.${option}`), value: option }))}
          selected={formik.values[name]}
          setFieldValue={formik.setFieldValue}
          setFieldTouched={formik.setFieldTouched}
          error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        />
      ) : null
    )
  );

  return (
    <div>
      <h3 className="fs-20 m-b-25">
        {t('camps.marketing.sub.duration')}
        <span className="c-primary-500 m-l-5 fs-18">*</span>
      </h3>

      <div className="input_max">
        <InputNumber
          name="duration"
          label={t('camps.marketing.form.duration')}
          min={1}
          max={20}
          setFieldValue={formik.setFieldValue}
          value={formik.values.duration}
          isDisabled={!isCreation}
        />
      </div>

      <hr className="m-t-30 m-b-40" />

      <h3 className="fs-20 m-b-25">
        {t('camps.marketing.sub.startDay')}
        <span className="c-primary-500 m-l-5 fs-18">*</span>
      </h3>

      <div className="d-flex">
        {getInputTags('startDay', startDays?.data?.campStartDays, isStartDaysLoading, 'camps.startDays')}
      </div>

      <hr className="m-t-30 m-b-40" />

      <h3 className="fs-20 m-b-25">
        {t('camps.marketing.sub.format')}
        <span className="c-primary-500 m-l-5 fs-18">*</span>
      </h3>

      <div className="d-flex">
        {getInputTags('format', formats?.data?.campFormats, isFormatsLoading, 'camps.formats')}
      </div>

    </div>
  );
}

Format.propTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
    values: PropTypes.shape({
      duration: PropTypes.number,
    }),
  }).isRequired,
  isCreation: PropTypes.bool,
};

Format.defaultProps = {
  isCreation: false,
};

export default Format;
